import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardBody } from '@components/card/card.jsx';
import { cleanUpElementLinkDeatail } from '@store/HR/Payroll/ElementLinkSlice';
// import {
//   AddElementLink,
//   changeActiveElementLink,
//   GetElementLinkDeatail
// } from '@store/HR/Payroll/PayrollSlice.js';
import {
  AddElementLink,
  changeActiveElementLink,
  GetElementLinkDeatail
} from '@store/HR/Payroll/ElementLinkSlice';
import Loader from '@components/Shared/Loader/Loader.jsx';
import { Form } from 'react-bootstrap';
import CustomAlert from '@components/Shared/Alert/CustomAlert.js';
import showConfirmation from '@components/Shared/Alert/Confirmation.js';
import Breadcrumb from '@components/Shared/Breadcrumb.js';
import Pagination from '@components/Shared/Pagination/Pagination.jsx';
import useGetAccounts from '@hooks/Finance/ChartAccountsDetails/useGetAccounts.js';
import ModalComponent from '@components/Modal/ModalComponent';
import UpdateLink from './UpdateLink';
import CodeInput from './CodeInput';
import NtxTable from '@components/DataTable/NtxTable';
import useGetElementLink from '@hooks/Payrolls/useGetElementLink';
import Conditions from './Conditions';
import Loading from '@components/Shared/Loader/Loading';
import NeatixModal from '@components/Modal/NeatixModal';

const ElementLink = () => {
  const [item, setItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(7);
  const { OptionsAccounts } = useGetAccounts();

  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);

  const { id } = useParams();
  const Navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const { ElementLinkDeatail, elementLink, elementType, loading, error } = useGetElementLink(id);

  useEffect(() => {
    return () => {
      dispatch(cleanUpElementLinkDeatail());
    };
  }, []);
  //______________________________________

  const handleActiveElement = item => {
    let msg = item.isActive ? 'هل أنت متأكد من إلغاء التفعيل ؟' : 'هل أنت متأكد من التفعيل ؟';

    showConfirmation(msg, () => {
      dispatch(changeActiveElementLink(item.id))
        .unwrap()
        .then(() => {
          CustomAlert({ action: 'Add', msg: '' });
          dispatch(GetElementLinkDeatail(id));
        })
        .catch(error => {
          console.log(error);
          CustomAlert({ action: 'Info' });
        });
    });
  };

  const formik = useFormik({
    initialValues: {
      elementTypeId: '',
      transferToGl: false,
      accountId: ''
    },
    onSubmit: values => {
      dispatch(
        AddElementLink({
          payrollId: id,
          elementTypeId: values.elementTypeId,
          transferToGl: values.transferToGl,
          accountId: values.transferToGl ? values.accountId : null,

          // priority: 0,
          formula: 'string',
          isActive: true
        })
      )
        .unwrap()
        .then(() => {
          formik.resetForm();
          CustomAlert({ action: 'Add' });
          dispatch(GetElementLinkDeatail(id));
        })
        .catch(error => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Info' });
          console.log(error);
        });
    },
    validate: values => {
      const errors = {};
      if (!values.elementTypeId) {
        errors.elementTypeId = 'Please select an option';
      }
      return errors;
    }
  });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Status'), key: 'Status' },
    // { title: t('الترحيل للمالية'), key: 'TransfertoGl' },
    { title: t('Account'), key: 'Account' },
    // { title: t('Status'), key: 'Status' },

    { title: t(''), key: 'action', className: 'text-end', sortable: false }
  ];

  console.log(elementLink);

  const tableData =
    elementLink &&
    elementLink?.map(item => {
      let name = i18n.language === 'en' ? item.name : item.name2;
      // let rowClass;

      return {
        Name: (
          <div className='d-flex flex-column'>
            <div className=''>{name}</div>

            <div className='d-flex  align-items-center mt-1'>
              <span className='badge bg-info text-white me-2'>{item.uom}</span>
              {item.isRecurring ? (
                <span className='badge bg-success text-white'>{t('Recurring')}</span>
              ) : (
                <span className='badge bg-secondary text-white'>{t('Non-Recurring')}</span>
              )}
            </div>
          </div>
        ),
        Status: (
          <>
            {item.isActive ? (
              <span className='badge bg-success w-50 text-dark'>{t('isActive')}</span>
            ) : (
              <span className='badge bg-danger w-50 text-dark'>{t('InActive')}</span>
            )}
          </>
        ),
        TransfertoGl: (
          <>
            {item.transferToGl ? (
              <span className='badge bg-success '>قابل للترحيل للمالية</span>
            ) : (
              <span className='badge bg-warning  '>غير قابل للترحيل للمالية</span>
            )}
          </>
        ),
        Account: item.transferToGl ? (
          i18n.language === 'ar' ? (
            item.accountName2
          ) : (
            item.accountName
          )
        ) : (
          <span className='badge bg-danger w-50'>{t('NotAvailable')}</span>
        ),
        action: (
          <>
            {/* <button
            type='button'
            className={`btn btn-sm m-0 ${
              item.isActive ? ' btn-outline-danger' : 'btn-outline-success'
            }`}
            onClick={() => handleActiveElement(item)}
          >
            {!item.isActive ? t('تفعيـــل') : t('إلغاء التفعيـل')}
          </button> */}
            <button
              type='button'
              className='btn btn-theme btn-sm ms-3'
              // data-bs-toggle='modal'
              // data-bs-target='#Edit'
              onClick={() => {
                setItem(item);
                setShow1(true);
              }}
            >
              <i className='fa fa-calculator me-2'></i>
              {t('Edit')}
            </button>
          </>
        )
      };
    });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  const titleModal = () => {
    return (
      <div className=''>
        {t('Edit')}
        {'  '}
        <span className='text-theme'>
          {`(${i18n.language === 'en' ? item?.name : item?.name2})`}
        </span>
      </div>
    );
  };
  const titleModal2 = () => {
    var payrollName =
      i18n.language === 'ar'
        ? ElementLinkDeatail?.payroll?.name2
        : ElementLinkDeatail?.payroll?.name;

    const subtitle =
      i18n.language === 'ar'
        ? 'استخدم الشروط لتقييد تطبيق حساب الراتب حسب معايير مثل الموقع، أو الوظيفة، أو المنصب.'
        : 'Use conditions to restrict salary calculation based on criteria such as location, job, or position.';

    return (
      <>
        <div>
          {t('Conditions')}
          {'  '}
          <span className='text-theme'>{`( ${payrollName} )`}</span>
        </div>
        <div className='text-muted small mt-1'>
          <small>{subtitle}</small>
        </div>
      </>
    );
  };

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: t('Payrolls'),
              link: '/Pay/payrolls'
            },
            {
              name: t('PayrollSettings'),
              link: null
            }
          ]}
          PageName={t('PayrollSettings')}
          subtitle={
            i18n.language === 'ar'
              ? ElementLinkDeatail?.payroll?.name2
              : ElementLinkDeatail?.payroll?.name
          }
        />

        <div className='ms-auto'>
          <button
            type='button'
            className=' btn me-1 btn-default w-100'
            onClick={() => Navigate(-1, { replace: true })}
          >
            <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
          </button>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <Loader loading={loading} />

            <Form onSubmit={formik.handleSubmit}>
              <div className='row  mt-2 '>
                <div className='col-lg-6 mb-3 '>
                  <div className='input-group flex-nowrap'>
                    <span className='input-group-text text-theme fw-bold'>{t('Elemente')}</span>
                    <Select
                      isLoading={loading}
                      className=' w-100'
                      classNamePrefix='react-select'
                      isRtl
                      isSearchable={true}
                      options={elementType}
                      onChange={option => formik.setFieldValue('elementTypeId', option.value)}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                      }}
                      formatOptionLabel={option => (
                        <div className='d-flex justify-content-between align-items-center'>
                          <div className='text-truncate me-3' style={{ maxWidth: '60%' }}>
                            {option.label}
                          </div>
                          <div className='d-flex flex-wrap gap-1'>
                            <span className='badge bg-info text-white'>{option.uom}</span>
                            <span
                              className={`badge text-white ${
                                option.isRecurring ? 'bg-success' : 'bg-secondary'
                              }`}
                            >
                              {option.isRecurring ? t('Recurring') : t('Non-Recurring')}
                            </span>
                          </div>
                        </div>
                      )}
                    />
                  </div>
                  {formik.errors.elementTypeId && formik.touched.elementTypeId && (
                    <div>{formik.errors.elementTypeId}</div>
                  )}
                </div>

                {/* <div className='col-xl-2 text-center'>
                <div className='form-group mb-3'>
                  <label className='form-label'>ترحيل للمالية</label>
                  <Form.Check
                    style={{ margin: '10px 40px' }}
                    type='checkbox'
                    name='transferToGl'
                    onChange={formik.handleChange}
                    value={formik.values.transferToGl}
                  />
                </div>
              </div>

              <div className='col-xl-4 '>
                {formik.values.transferToGl && (
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Accounts')}</label>
                    <Select
                      classNamePrefix='react-select'
                      className=' w-100'
                      isLoading={loading}
                      isSearchable={true}
                      isClearable
                      options={OptionsAccounts}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      onChange={option => {
                        formik.setFieldValue('accountId', option === null ? null : option.value);
                      }}
                      // value={OptionsAccounts?.find((f) => f.value === id)}
                    />
                  </div>
                )}
              </div> */}

                <div className='col-xl-2   '>
                  <div className=' form-group mb-3 d-flex justify-content-end '>
                    <button
                      disabled={formik.isSubmitting}
                      type='submit'
                      className='btn me-1 btn-theme w-100'
                    >
                      <i className='fas fa-plus fa-fw me-1'></i>
                      {formik.isSubmitting ? 'Adding...' : t('Add')}
                    </button>
                  </div>
                </div>
                <div className='col-xl-4  ms-auto '>
                  <div className=' form-group mb-3 d-flex justify-content-end '>
                    <button
                      disabled={formik.isSubmitting}
                      type='button'
                      className='btn me-1 btn-outline-theme  '
                      data-bs-toggle='modal'
                      data-bs-target='#Conditions'
                      // onClick={() => setShow2(true)}
                    >
                      {/* <i class="fas fa-clipboard-list fa-fw me-1"></i>  */}
                      <i className='fas fa-file-alt fa-fw me-1'></i>

                      {t('Conditions')}
                    </button>
                  </div>
                </div>
              </div>
            </Form>

            <div className='mt-3'>
              <NtxTable
                data={tableData || []}
                columns={columns}
                dataPerPage={8}
                theadClass=''
                tableClass='table text-nowrap table-hover '
                // enableSearch
                // showRecordsSelector
              />
            </div>
          </CardBody>
        </Loading>
      </Card>

      <NeatixModal setShow={setShow1} show={show1} title={titleModal()} size='xl'>
        {!!item?.id && <UpdateLink item={item} />}
      </NeatixModal>

      {/* <ModalComponent id={'Edit'} title={titleModal()} size='xl'>
        {!!item?.id && <UpdateLink item={item} />}
        </ModalComponent> */}
      <ModalComponent id={'Conditions'} title={titleModal2()} size='xl'>
        {<Conditions />}
      </ModalComponent>
      {/* <NeatixModal setShow={setShow2} show={show2} title={titleModal2()} showHeader={false} bodyClassName='p-0' size='xl'>
        {<Conditions  titleModal2={titleModal2()}/>}
      </NeatixModal> */}
    </>
  );
};
export default ElementLink;
